/**
 * Workflow entity validation rules.
 */

import { getEntityAttrString } from './ReusableValidation';
import type { ValidationWarning } from './ReusableValidation';

const VALID_TYPES = ['action', 'authorization', 'request'];

export function getWorkflowWarnings(data: Record<string, any>): ValidationWarning[] {
    const warnings: ValidationWarning[] = [];

    const displayName = getEntityAttrString(data, 'DisplayName');
    if (!displayName) {
        warnings.push({
            message: 'Display Name should not be empty.',
            severity: 'warning',
            attributeDisplayNames: ['Display Name']
        });
    }

    const type = getEntityAttrString(data, 'Type');
    if (!type) {
        warnings.push({
            message: 'Type must be specified (Action, Authorization, or Request).',
            severity: 'warning',
            attributeDisplayNames: ['Type']
        });
    } else if (!VALID_TYPES.includes(type.toLowerCase())) {
        warnings.push({
            message: `Invalid Type "${type}". Must be Action, Authorization, or Request.`,
            severity: 'warning',
            attributeDisplayNames: ['Type']
        });
    }

    return warnings;
}
